import {put,takeEvery} from "redux-saga/effects"
import store from "store";
import {initialHelperState, SET_ACTIVE_SHAPE_ID, SET_ACTIVE_VIEW} from "shape-edit/reducers";
import {SET_HELPER} from "actions";
import {HelperType} from "app/types/app-types";
import {
    ContentType,
    getHelperContentByActiveShape,
    getHelperContentByActiveView
} from "../components/helper";

import {ACTIVE_VIEW_EDIT_SHAPE, ActiveViewType} from "../containers/Editor";
import { selectFormValue, selectFormValues } from "app/reducers/form";
import { getFormName } from "shape-edit/forms/helpers";

export function* handleActiveShapeOrViewChanged(action) {
    const currentState : any = store.getState()
    const currentActiveView : ActiveViewType = currentState.activeView ?? null
    const currentActiveShapeId: ActiveViewType = currentState.activeShapeId ?? null

    const formName = getFormName(currentState.isAlt)

    let content : ContentType = null

    if (currentActiveView === ACTIVE_VIEW_EDIT_SHAPE && currentActiveShapeId) {
        const activeShape = selectFormValue(currentState,formName,'shapes')[currentActiveShapeId]
        content = getHelperContentByActiveShape(activeShape)
    } else if ((action.type === SET_ACTIVE_SHAPE_ID && !action.payload) ||
        !currentState ||
        !selectFormValues(currentState,formName) ||
        !selectFormValue(currentState,formName,'shapes') ||
        (action.type === SET_ACTIVE_SHAPE_ID && !selectFormValue(currentState,formName,'shapes')[action.payload])
    ) {
        const closedAt = currentState?.helper?.closedAt || null
        yield put({
            type: SET_HELPER,
            payload: { ...initialHelperState, closedAt: closedAt }
        })
        return
    } else if (action.payload === ACTIVE_VIEW_EDIT_SHAPE && action.type === SET_ACTIVE_SHAPE_ID) {
        const activeShape = selectFormValue(currentState,formName,'shapes')[action.payload]
        content = getHelperContentByActiveShape(activeShape)
    } else if (action.type === SET_ACTIVE_VIEW) {
        content = getHelperContentByActiveView(action.payload, currentState)
    }

    if (content && content.text) {
        const newHelperState: HelperType = {
            ...currentState.helper,
            title: content.title,
            text: content.text,
            isVisible: true,
            //isMaximized: currentState.helper.closedAt ? false : true  //FIE-884
        }

        yield put({
            type: SET_HELPER,
            payload: newHelperState,
        })
    } else {
        const closedAt = currentState?.helper?.closedAt || null
        if (action.payload !== ACTIVE_VIEW_EDIT_SHAPE) {
            yield put({
                type: SET_HELPER,
                payload: { ...initialHelperState, closedAt: closedAt },
            })
        }
    }
}

export function* watchActiveShapeOrViewChanged() {
    yield takeEvery([SET_ACTIVE_SHAPE_ID, SET_ACTIVE_VIEW], handleActiveShapeOrViewChanged)
}
